import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { useSEO, useSchema } from '../../utils/seo';

export default function Blog() {
  useSEO({
    title: 'Blog - Strategien und Tipps zum Online-Geldverdienen | EarnProof',
    description: 'Erfahre mehr über bewährte Methoden, Tipps und Tricks zum Online-Geldverdienen. Echte Erfahrungen, ehrliche Reviews und detaillierte Anleitungen.',
    keywords: 'earning strategien, geld verdienen tipps, mistplay strategie, online income blog, earning apps tutorial',
    canonical: 'https://example.com/blog',
  });

  useSchema({
    type: 'Blog',
    data: {
      name: 'EarnProof Blog',
      description: 'Strategien und Tipps zum Online-Geldverdienen',
      url: 'https://example.com/blog',
      publisher: {
        '@type': 'Organization',
        name: 'EarnProof',
      },
    },
  });

  const categories = [
    { name: 'Alle', count: 1, active: true },
    { name: 'Strategien', count: 1, active: false },
    { name: 'Reviews', count: 0, active: false },
    { name: 'Tutorials', count: 0, active: false },
  ];

  const featuredArticle = {
    id: 1,
    title: 'Wie ich mit Mistplay und Google Play Guthaben 175-330€ monatlich verdiene',
    excerpt: 'Entdecke meine bewährte Strategie ohne echten Geldeinsatz. Lerne, wie du mit Mistplay Google Play Guthaben sammelst und dieses clever in Freecash und Scrambly investierst, um deine Einnahmen zu multiplizieren.',
    category: 'Strategien',
    date: '15. Januar 2025',
    readTime: '8 Min.',
    image: 'https://public.readdy.ai/ai/img_res/1e5f0e20ae9149491e60bb9fff04a253.jpg',
    featured: true,
    tags: ['Strategie', 'Mistplay', 'Ohne Einsatz', 'Google Play'],
    link: '/blog/mistplay-strategie'
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-purple-500">Blog</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Erfahre mehr über meine bewährten Methoden, Tipps und Tricks zum Online-Geldverdienen. Echte Erfahrungen, ehrliche Reviews und detaillierte Anleitungen.
          </p>
        </div>
      </section>

      {/* Categories */}
      <section className="pb-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category.name}
                className={`px-6 py-3 rounded-full font-medium transition-all whitespace-nowrap ${
                  category.active
                    ? 'bg-gradient-to-r from-teal-500 to-purple-500 text-white'
                    : 'bg-white/5 text-gray-300 hover:bg-white/10 border border-white/10'
                }`}
              >
                {category.name} ({category.count})
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="pb-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Featured Article */}
            <Link 
              to={featuredArticle.link}
              className="group bg-white/5 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/10 hover:border-teal-500/50 transition-all hover:scale-105 cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={featuredArticle.image}
                  alt={featuredArticle.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-4 py-1.5 bg-teal-500 text-white rounded-full text-sm font-bold">
                    Featured
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center gap-3 mb-4">
                  <span className="px-3 py-1 bg-purple-500/20 text-purple-400 rounded-full text-xs font-medium">
                    {featuredArticle.category}
                  </span>
                  <span className="text-gray-400 text-sm">{featuredArticle.date}</span>
                  <span className="text-gray-400 text-sm">• {featuredArticle.readTime}</span>
                </div>
                
                <h3 className="text-lg font-bold text-white mb-3 group-hover:text-teal-400 transition-colors line-clamp-2">
                  {featuredArticle.title}
                </h3>
                
                <p className="text-gray-400 text-sm mb-4 line-clamp-3">
                  {featuredArticle.excerpt}
                </p>
                
                <div className="flex flex-wrap gap-2 mb-4">
                  {featuredArticle.tags.map((tag) => (
                    <span 
                      key={tag}
                      className="px-3 py-1 bg-white/5 text-gray-400 rounded-full text-xs border border-white/10"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
                
                <div className="flex items-center gap-2 text-teal-400 font-medium group-hover:gap-3 transition-all">
                  Weiterlesen
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

